import ConfirmationSignOutModal, {
  ConfirmationSignOutModalProps,
} from './ConfirmationSignOutModal';

export type { ConfirmationSignOutModalProps };
export default ConfirmationSignOutModal;
